import React from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
const rows: React.ReactNode[] = [<>
    Mornings and bedtimes <strong className="font-extrabold" data-id="element-61" data-mp="c7ujd4b4t7r3">stop being a fight</strong> and start{' '}
    <span className="text-gain" data-id="element-62" data-mp="c9ywmcux7j41">running on their own</span> — no yelling, no losing your temper.
  </>, <>
    Your kid <strong className="font-extrabold" data-id="element-63" data-mp="3fokv7zteaf0p">follows the routine</strong>{' '}
    <span className="text-gain" data-id="element-64" data-mp="3fqffrd0r8549">without you having to say it forty times</span>.
  </>, <>
    You learn to <span className="text-gain" data-id="element-65" data-mp="3kps2zyvjfe7d">set limits</span>{' '}
    <strong className="font-extrabold" data-id="element-66" data-mp="3oozr1t3zjcig">
      without yelling, punishing, or feeling like the bad guy
    </strong>{' '}
    afterward.
  </>, <>
    Your kid <strong className="font-extrabold" data-id="element-67" data-mp="3tlzpbhulfaz0">stops cooperating out of fear</strong> and{' '}
    <span className="text-gain" data-id="element-68" data-mp="1414qibk1skkv">starts cooperating because it feels good</span>.
  </>, <>
    You find out you can parent with <span className="text-gain" data-id="element-69" data-mp="pdanq5ggxbxs">less guilt, less yelling</span> —
    and <strong className="font-extrabold" data-id="element-70" data-mp="pcj47t05b4nv">a lot more connection</strong>.
  </>];
export function Benefits() {
  return <Section data-id="element-71" data-mp="kcd6pw772nxv">
      <FadeUp data-id="element-72" data-mp="feuzqbcqmisi">
        <Heading2 data-id="element-73" data-mp="febrxngsxas7">
          What actually changes
          <br data-id="element-74" data-mp="fh7ob7d03rej" />
          in your home
        </Heading2>

        <ul className="mx-auto mt-10 max-w-[520px] space-y-[26px]" data-id="element-75" data-mp="af08g6p1vr6x">
          {rows.map((row, index) => <li key={index} className="flex items-start gap-3 text-left text-[17px]" data-id="element-76" data-mp="6f88ujhmwvdp" data-mpi={index}>
              <span aria-hidden="true" className="flex-none text-[18px] leading-[1.6] text-star" data-id="element-77" data-mp="1mouvlf1by8d">
                ★
              </span>
              <span data-id="element-78" data-mp="3suavt6addmlj">{row}</span>
            </li>)}
        </ul>
      </FadeUp>
    </Section>;
}